import { render, staticRenderFns } from "./JjLogRecord.vue?vue&type=template&id=466d66b1&scoped=true"
import script from "./JjLogRecord.vue?vue&type=script&lang=js"
export * from "./JjLogRecord.vue?vue&type=script&lang=js"
import style0 from "./JjLogRecord.vue?vue&type=style&index=0&id=466d66b1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466d66b1",
  null
  
)

export default component.exports